import InitializeLayout from '@js/layout';

import HomeManager from '@js/managers/homeManager';

import {letBrowserHandleInput} from '@js/modules/utils';

InitializeLayout();

letBrowserHandleInput().then(() => HomeManager.initialize());
